export default "__VITE_ASSET__CS_4J6hz__"